import { Component, Input, OnChanges } from '@angular/core';
import { ComponentData, TabData } from '@ddt-web/data-service';

@Component({
	selector: 'esg-no-rating-holdings',
	templateUrl: './esg-no-rating-holdings.component.html',
	styleUrls: ['./esg-no-rating-holdings.component.scss']
})
export class EsgNoRatingHoldingsComponent implements OnChanges {

	@Input() public data: ComponentData;
	public tickersWithNoRating: string[] = [];

	public ngOnChanges(): void {
		if (this.data.success) {
			const noHoldingsTab: TabData = this.data.getTabById('esg.noRating.holdings');
			const tableData = noHoldingsTab?.tableData[0];
			this.tickersWithNoRating = tableData?.headersY?.map((cellData) => cellData?.formattedValue).filter(ticker => !!ticker);
		}
	}
}
